import { Link } from '@igs-web/common-ui-components/_atoms/link/link'
import styled from 'styled-components'

export const NavLink = styled(Link)`
    &:hover {
        text-decoration: none;
    }
`
